import Api, { baseURL } from './Api'

const BASE = `${baseURL('v2')}/uploads`

export default {
  signedParams() {
    return Api.get(`${BASE}/signed-params`)
  },
}
